import React from 'react';

export const path =
  'M4.21346105,10.8471991 C4.99618929,11.4151156 5.95898642,11.75 7,11.75 C9.62335256,11.75 11.75,9.62335256 11.75,7 C11.75,5.95898642 11.4151156,4.99618929 10.8471991,4.21346105 L4.21346105,10.8471991 Z M3.15280088,9.78653895 L9.78653895,3.15280088 C9.00381071,2.58488444 8.04101358,2.25 7,2.25 C4.37664744,2.25 2.25,4.37664744 2.25,7 C2.25,8.04101358 2.58488444,9.00381071 3.15280088,9.78653895 Z M7,13 C3.6862915,13 1,10.3137085 1,7 C1,3.6862915 3.6862915,1 7,1 C10.3137085,1 13,3.6862915 13,7 C13,10.3137085 10.3137085,13 7,13 Z';

export default class Closed extends React.PureComponent {
  render() {
    return (
      <g>
        <rect width="14" height="14" opacity="0" />
        <path d={path} className="fill-current" />
      </g>
    );
  }
}
